import * as React from "react"

const Male = (props) => {
    const { color, size } = props
    return (<svg width={size ? size : "1200pt"} height={size ? size : "1200pt"} version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg" alt="Plus icon">
        <path 
            d="m705.8 350.62c-12.52 0-22.672 10.148-22.672 22.672 0 12.52 10.148 22.672 22.672 22.672h66.125l-90.215 90.215c-34.922-27.941-79.008-44.871-127.05-44.871-112.42 0-204.04 91.621-204.04 204.04s91.621 204.04 204.04 204.04 204.04-91.621 204.04-204.04c0-48.113-16.859-92.348-44.871-127.29l90.215-90.215v66.359c0 12.52 10.148 22.672 22.672 22.672 12.52 0 22.672-10.148 22.672-22.672v-120.91c0-6.0156-2.3906-11.781-6.6406-16.031-4.25-4.2539-10.016-6.6406-16.031-6.6406zm-151.14 136.03c87.914 0 158.7 70.785 158.7 158.7s-70.785 158.7-158.7 158.7-158.7-70.785-158.7-158.7 70.785-158.7 158.7-158.7z" 
            fill={color}
        />
    </svg>)
}

export default Male